export const BASE_PATH = "";
export const PRESALE_ADDRESS = '0xaF43057978E7F2C19a3EAd5A0153c80EBf6DB53D'